import api from "@/lib/api";
import { toast } from "sonner";

function loadScript(src) {
    return new Promise((resolve) => {
        if (document.querySelector(`script[src="${src}"]`)) return resolve(true);
        const s = document.createElement("script");
        s.src = src;
        s.onload = () => resolve(true);
        s.onerror = () => resolve(false);
        document.body.appendChild(s);
    });
}

/**
 * Trigger Razorpay checkout for a given product + tracking_id.
 * onSuccess(verifyResponse) is called after server-side verification.
 */
export async function payWithRazorpay({ productCode, trackingId, customer, onSuccess, onFailure }) {
    const ok = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
    if (!ok) {
        toast.error("Could not load payment gateway");
        return;
    }
    let order;
    try {
        const { data } = await api.post("/payments/create-order", {
            product_code: productCode,
            tracking_id: trackingId,
        });
        order = data;
    } catch (err) {
        console.error(err);
        toast.error(err?.response?.data?.detail || "Could not initialize payment");
        return;
    }

    const options = {
        key: order.key_id,
        amount: order.amount,
        currency: order.currency,
        name: "Aangan Theory",
        description: order.description,
        order_id: order.order_id,
        prefill: {
            name: customer?.name || "",
            email: customer?.email || "",
            contact: customer?.phone || "",
        },
        notes: { tracking_id: trackingId },
        theme: { color: "#FF9933", backdrop_color: "#000000" },
        handler: async (response) => {
            try {
                const { data } = await api.post("/payments/verify", {
                    razorpay_order_id: response.razorpay_order_id,
                    razorpay_payment_id: response.razorpay_payment_id,
                    razorpay_signature: response.razorpay_signature,
                });
                onSuccess?.(data);
            } catch (err) {
                console.error(err);
                onFailure?.(err);
                toast.error("Payment verification failed");
            }
        },
        modal: {
            ondismiss: () => onFailure?.(new Error("Cancelled")),
        },
    };
    const rzp = new window.Razorpay(options);
    rzp.open();
}
